import { render, staticRenderFns } from "./SchoolSelectboxAutoComplate.vue?vue&type=template&id=07397de6&"
import script from "./SchoolSelectboxAutoComplate.vue?vue&type=script&lang=js&"
export * from "./SchoolSelectboxAutoComplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports